export class AccessorialModel {
  static fromApiResource(
    resource: import("./api/orders/accessorials").OrderAccessorialResource
  ): AccessorialModel {
    const model = new AccessorialModel();

    model.id = resource.number;
    model.charge = resource.charge;
    model.description = resource.description;
    model.itemCode = resource.itemCode;
    model.quantity = resource.quantity;
    model.rate = resource.rate;
    model.tarriffCode = resource.tarriffCode;
    model.tarriffItem = resource.tarriffItem;
    model.tarriffNumber = resource.tarriffNumber;
    return model;
  }
  id: number;
  description: string;
  itemCode: string;
  quantity?: number = 0;
  rate?: number = 0;
  charge?: number = 0;
  tarriffNumber: string;
  tarriffCode: string;
  tarriffItem: string;
  fixAll: boolean = false;
  saving: boolean = false;
}
